import script from "./Experience.vue?vue&type=script&setup=true&lang=ts"
export * from "./Experience.vue?vue&type=script&setup=true&lang=ts"

import "./Experience.vue?vue&type=style&index=0&id=5772959d&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5772959d"]])

export default __exports__